var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { flexItemStyle, responsiveFlexStyle, } from '../../styles/internal';
import { Box } from '../box';
const Root = styled(Box)(flexItemStyle, responsiveFlexStyle);
export const Flex = forwardRef((props, ref) => {
    const { align, as, direction = 'row', justify, wrap } = props, restProps = __rest(props, ["align", "as", "direction", "justify", "wrap"]);
    return (React.createElement(Root, Object.assign({ "data-ui": "Flex" }, restProps, { "$align": align, "$direction": direction, "$justify": justify, "$wrap": wrap, forwardedAs: as, ref: ref })));
});
Flex.displayName = 'Flex';
//# sourceMappingURL=flex.js.map